<template>
  <div style="display: inline-block; margin: 0 10px">
    <el-button
      type="danger"
      :disabled="disabled"
      @click="internalVisible = true"
    >
      批量分配
    </el-button>
    <el-dialog
      title="资源批量分配"
      :visible.sync="internalVisible"
      @close="closeDialog"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="意向国家">
          <el-select
            v-model="form.hope_country"
            class="jm-input-common"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in countries"
              :label="item.value"
              :value="item.id"
              :key="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="咨询老师">
          <el-select
            v-model="form.crm_sayer"
            class="jm-input-common"
            clearable
            placeholder="请选择"
            filterable
            :disabled="!form.hope_country"
          >
            <el-option-group v-for="(group, k) in teachers" :key="k" :label="k">
              <el-option
                v-for="item in group"
                :key="`${item.country}_${item.userid}`"
                :label="item.truename"
                :value="item.userid"
              />
            </el-option-group>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="internalVisible = false">取 消</el-button>
        <el-button type="primary" @click="doAllot" :loading="saving">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { isEmpty } from '@/utils/utils';

export default {
  name: 'BatchAllot',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    dataset: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      internalVisible: false,
      saving: false,
      form: {
        hope_country: null,
        crm_sayer: null,
        data: [],
      },
    };
  },
  computed: {
    countries() {
      if (this.dataset.country) {
        return this.dataset.country;
      }
      return [];
    },
    teachers() {
      if (isEmpty(this.dataset.originAdvisoryTeacher)) {
        return [];
      }
      const teachersGroup = {};
      const originTeachers = this.dataset.originAdvisoryTeacher;
      Object.entries(originTeachers).forEach(([char, teachers]) => {
        teachers = teachers.filter((item) => {
          if (item.country === this.form.hope_country) {
            return true;
          }
          return false;
        });
        if (!isEmpty(teachers)) {
          teachersGroup[char] = teachers;
        }
      });
      const autoAllot = [
        {
          first_char: '0',
          truename: '自动分配',
          userid: -1,
        },
      ];
      teachersGroup['0'] = autoAllot;
      return teachersGroup;
    },
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false);
      this.form.hope_country = null;
      this.form.crm_sayer = null;
    },
    async doAllot() {
      if (!this.form.crm_sayer) {
        this.$message.error('请选择咨询老师');
        return false;
      }
      try {
        await this.$confirm('确定进行批量分配');
      } catch (error) {
        return false;
      }
      this.form.data = this.data;
      this.$message('处理中...');
      this.saving = true;
      await this.$http._post({
        url: '/index/Student/batchAllot',
        data: this.form,
      });
      this.saving = false;
      this.internalVisible = false;
      this.$message('分配成功');
      this.$emit('success', true);
    },
  },
  watch: {
    visible(v) {
      this.internalVisible = v;
    },
  },
};
</script>
